import React, { useEffect, useState } from "react";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";
import "../../MainStyle.css";
import { useNavigate } from "react-router-dom";
import { getStorage } from "../modals/Storage";
import { openNewPage } from "../modals/Constants";
import BottomNavbar from "../other-components/BottomNavbar/Navbar";
import styles from "../css/Screens.module.css";
import general from "../css/General.module.css";

function Deposit() {
  const navigate = useNavigate();
  const [showLoading, setShowLoading] = useState(false);

  const [pageConst, setConstants] = useState({
    pageTitle: "Deposit",
    inRechargeAmnt: "",
    recordList: [],
  });

  const onInputValChange = (source, data) => {
    if (source == "rechargeamount") {
      setConstants((previousState) => {
        return { ...previousState, inRechargeAmnt: data };
      });
    }
  };

  const rechargeNow = () => {
    if (
      getStorage("paymentURL") &&
      Number(pageConst.inRechargeAmnt) >= getStorage("minrecharge")
    ) {
      openNewPage(
        getStorage("paymentURL") +
        "?am=" +
        pageConst.inRechargeAmnt +
        "&crudentials=" +
        getStorage("uid") +
        "&currency=INR"
      );
    }
  };

  const setAllRechargeOptions = () => {
    let tempData = [];
    const recentBetArr = getStorage("rechargeoptions").split(",");

    for (let i = 0; i < recentBetArr.length; i++) {
      tempData.push(
        <div
          key={i}
          className={`pd-10-15 v-center cl-white br-5 ft-sz-16 ${recentBetArr[i] == pageConst.inRechargeAmnt ? 'bg-selected' : 'br-a-l-white-2'}`}
          onClick={() => onInputValChange("rechargeamount", recentBetArr[i])}
        >
          ₹{recentBetArr[i]}
        </div>
      );
    }

    setConstants((previousState) => {
      return { ...previousState, recordList: tempData };
    });
  };

  useEffect(() => {
    setAllRechargeOptions();
  }, [pageConst.inRechargeAmnt]);

  useEffect(() => {
    if (!getStorage("uid")) {
      navigate("/login", { replace: true });
    } else {
      setAllRechargeOptions();
    }
  }, []);

  return (
    <div className={[general.appContents].join(" ")}>
      <LoadingDialog intentData={showLoading} />

      <div
        className={[
          general.respWidth,
          general.minHeight100vh
        ].join(" ")}
      >
        <div className="w-100 ps-sticky ps-tp row-view pd-10-15 z-i-90 bg-custom-1">
          <div className="col-view">
            <p className="ft-sz-22 cl-white">Wallet</p>
            <p className="ft-sz-16 cl-l-white">Balance: ₹{Number(getStorage("balance")).toLocaleString()}</p>
          </div>
        </div>

        <div className="col-view pd-15 mg-t-10">
          <p className="ft-sz-18 cl-white">Payment method</p>
          <p className="ft-sz-13 cl-l-white-3">Try other payment methods when facing failures.</p>
        </div>

        <div className="row-view pd-10-15 bg-l-white-5 mg-t-10">
          <img src={require("../media/icons/upi_icon.png")} className="h-40-p" />

          <div className="col-view mg-l-15 flex-grow">
            <p className="ft-sz-18 cl-white">UPI</p>
            <p className="ft-sz-13 cl-l-white">₹{getStorage("minrecharge")} - ₹50,000</p>
          </div>

          <div className="selected-radio-circle">
            <div></div>
          </div>
        </div>

        <div className="col-view pd-15 mg-t-10">
          <p className="ft-sz-18 cl-white">Deposit</p>

          <div className="w-100 g-v-2 mg-t-15">
            {pageConst.recordList}
          </div>

          <div className="row-view pd-0-15 bg-l-white mg-t-15">
            <span className="cl-l-grey ft-sz-20 pd-0-15 br-a-l-white-2">INR</span>
            <input
              type="number"
              className="cutm-inp ft-sz-28 h-60-p cl-white inp-ph-l-color mg-l-15"
              value={pageConst.inRechargeAmnt}
              placeholder="Enter Amount"
              onChange={(e) =>
                onInputValChange("rechargeamount", e.target.value)
              }
            ></input>
          </div><div className="col-view bg-l-white">

          </div>

          <div className="v-center ft-sz-20 pd-10-15 cl-white mg-t-20 br-5 bg-selected" onClick={() => rechargeNow()}>Deposit</div>

          <div
            className={[
              general.colView,
              styles.depositRulesView,
            ].join(" ")}
          >
            <p>
              The System take some time for approval.
            </p>
            <p>
              Please wait patiently and fill the correct ( 12 DIGIT UTR)
            </p>
            <p>
              If the UTR number is incorrect, the amount will not be credited to your account.
            </p>
          </div>
        </div>

        <div className="mg-t-13em"></div>

        <BottomNavbar activeBar="recharge" />
      </div>
    </div>
  );
}

export default Deposit;
